/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "SendVerificationEmailRequest": {
                "fields": {
                  "idempotenceToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "SendVerificationEmailResponse": {
                "fields": {
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SendVerificationEmailRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.SendVerificationEmailResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE SendVerificationEmailRequest @ squareup/corporate_card/service/send_verification_email.proto at 9:1
 */
export const SendVerificationEmailRequest = $root.lookupType('squareup.corporate_card.service.SendVerificationEmailRequest');
fixType(SendVerificationEmailRequest, {
  idempotenceToken: {
    required: true
  }
});
Builder.createAndAttachToType(SendVerificationEmailRequest);
/**
 * SOURCE SendVerificationEmailResponse @ squareup/corporate_card/service/send_verification_email.proto at 16:1
 */
export const SendVerificationEmailResponse = $root.lookupType('squareup.corporate_card.service.SendVerificationEmailResponse');
fixType(SendVerificationEmailResponse);
Builder.createAndAttachToType(SendVerificationEmailResponse);